import HighlightMessage, { HighlightMessageProps } from './HighlightMessage';

export type { HighlightMessageProps };
export default HighlightMessage;
